module.exports = __webpack_public_path__ + "img/创新同行.fb4075fe.jpg";